module.exports = __webpack_public_path__ + "5605cb184a2d3ff54604d3d1994de80c.png";